import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Content } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';

export const StepContent: React.FC = ({ children }) => {
  return (
    <Box mt="48">
      <Content>{children}</Content>
    </Box>
  );
};
